import { useToast } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EditorSidebar from './EditorSidebar';
import {
  useDiscardTemplateDraftMutation, useGetTemplateDraftQuery, useGetTemplateQuery, usePublishTemplateMutation, useUpdateTemplateMutation,
} from '../../Services/templates';
import { getForm } from '../FormSetup/formSlice';

const TemplateEditorSidebar = () => {
  const { templateId } = useParams();
  const [updateTemplate, { isLoading: isLoadingUpdate }] = useUpdateTemplateMutation();
  const [publishTemplate, { isLoading: isLoadingPublish }] = usePublishTemplateMutation();
  const [discardDraft, { isLoading: isLoadingDraft }] = useDiscardTemplateDraftMutation();
  const { data: form } = useGetTemplateQuery(templateId);
  const { data: draft } = useGetTemplateDraftQuery(templateId);
  const { dirty } = useSelector(getForm);
  const toast = useToast();
  const isLoading = isLoadingUpdate || isLoadingPublish || isLoadingDraft;

  const handlePublish = async () => {
    try {
      await updateTemplate();
      await publishTemplate(templateId);
      toast({
        title: 'Form published',
        status: 'success',
        variant: 'left-accent',
        isClosable: true,
        position: 'top',
        duration: 1000,
      });
    } catch (error) {
      toast({
        title: 'Error publishing form',
        description: 'Please try again later.',
        status: 'warning',
        variant: 'left-accent',
        isClosable: true,
        position: 'top',
        duration: 10000,
      });
    }
  };
  const handleDiscardDraft = () => {
    discardDraft(templateId);
  };
  return (
    <EditorSidebar
      isLoading={isLoading}
      handleDiscardDraft={handleDiscardDraft}
      handlePublish={handlePublish}
      newChanges={dirty || form?.updated !== draft?.updated}
    />
  );
};

export default TemplateEditorSidebar;
